export default __webpack_public_path__ + "static/media/open.18cfef1a.svg";